<app-card class="mt-4 only-stdcheck" contentClasses="p-4" headerClasses="is-hidden">
  <strong class="is-size-4 mb-1 is-block">What happens after you place your order?</strong>
  <ul>
    <li>Access your <strong>lab requisition form and your test code</strong> in your online account.</li>
    <li>
      The <strong>address of the test center</strong> you choose will also
      <strong>be visible in your account.</strong>
    </li>
    <li>Take your <strong>lab requisition form and your test code</strong> to the testing center.</li>
    <li><strong>Get tested.</strong> STD tests usually take 5 minutes or less.</li>
  </ul>
</app-card>
<app-card class="mt-4 only-healthlabs what-happens-next" contentClasses="p-5 is-relative" headerClasses="is-hidden">
  <strong class="is-size-4 mb-1 is-block has-text-weight-ultrabold has-text-dark"
    >What happens after you click “Place My Order”?</strong
  >
  <ul class="has-text-dark has-text-weight-semibold">
    <li>
      You'll receive an email containing a "Lab Requisition Form" with a test code. The address of the test center you
      chose is also included in the email.
    </li>
    <li>Take your Lab Requisition Form or your test code to the testing center.</li>
    <li>Get Tested. HealthLabs.com’s tests usually take 10 minutes or less.</li>
  </ul>
  <div class="mcafee-container">
    <img
      class="mcafee-logo"
      ngSrc="assets/img/logos/mcafee-logo.png"
      alt="McAfee Logo"
      width="160"
      height="75"
      priority
    />
  </div>
</app-card>
<app-card class="mt-4 only-analytehealth what-happens-next" contentClasses="p-5 is-relative" headerClasses="is-hidden">
  <strong class="is-size-4 mb-1 is-block has-text-weight-ultrabold has-text-dark"
    >What happens after you click “Place My Order”?</strong
  >
  <ul class="has-text-dark has-text-weight-semibold">
    <li>
      You'll receive an email containing a "Lab Requisition Form" with a test code. The address of the test center you
      chose is also included in the email.
    </li>
    <li>Take your Lab Requisition Form or your test code to the testing center.</li>
    <li>Get Tested. Analyte Health tests usually take 10 minutes or less.</li>
  </ul>
  <div class="mcafee-container">
    <img
      class="mcafee-logo"
      ngSrc="assets/img/logos/mcafee-logo.png"
      alt="McAfee Logo"
      width="160"
      height="75"
      priority
    />
  </div>
</app-card>
